<template>
  <div ref="topbox">
    <!-- sosTypeList -->
    <!-- 报警 -->
    <audio id="alarmA" :src="require('@/assets/alarm.mp3')" loop="true" />
    <div class="sosCall">
      <template v-for="(item, index) in sosTypeList">
        <div class="sosCallBox" v-if="item.showBoxType != 1" :key="index">
          <div v-if="item.cmd == 'push_sos'" class="newsosBox">
            <div style="position: relative;">
              <div class="colorBox" @click="closeSOS(item)">
                <i class="el-icon-close"></i>
              </div>
              <el-image fit="contain"
                :src="item.showBoxType == 3 ? require(`@/assets/sosTitBg1.png`) : require(`@/assets/sosTitBg2.png`)"
                style="width:100%" />
              <div class="sosMsgHeader" style="color: #fff">
                <div class="sosTitle">
                  <p style="font-size:22px;font-weight: bolder">{{ item.sosName }}</p>
                  <p style="font-size:16px;">{{ item.closetime }}S</p>
                </div>
              </div>
            </div>
            <div class="sosMsgContent" style="padding: 0 20px;">
              <div class="sosMsg" style="display:flex;align-items: flex-start;">
                <p style="width:27%;">电梯名称：</p>
                <p style="width:72%" :title="item.name" class="overName">{{ item.name }} </p>
              </div>
              <div class="sosMsg">
                <p style="width:27%">报警时间：</p>
                <p style="width:72%">{{ item.time }} </p>
              </div>
              <div class="sosMsg" v-if="item.code">
                <p style="width:27%">报警楼层：</p>
                <!-- {{item}} -->
                <p style="width:72%">{{ item.floor }} </p>
              </div>
            </div>
            <div class="sosMsgBottom">
              <el-button type="primary" size="small" v-if="
              (item.type==0||
              item.type==5||
              item.type==13||
              item.type==95||
              item.type==10||
              item.type==4||
              item.type==7||
              item.type==1 ||
              item.type==2 ||
              item.type==3||
              item.type==11||
              item.type==12 ||
              item.type==14 ||
              item.type==999 ||
              item.type==98 ||
              item.type==96 ||
              item.type==19 ||
              item.type==20 ||
              item.type==21)&&item.code != ''
              " @click="answerSOS(item)" style="width:100px">接听</el-button>
              <el-button type="info" size="small" @click="closeSOS(item)" :class="
              (item.type==0||
              item.type==5||
              item.type==13||
              item.type==95||
              item.type==10||
              item.type==4||
              item.type==7||
              item.type==1 ||
              item.type==2 ||
              item.type==3||
              item.type==11||
              item.type==12 ||
              item.type==14 ||
              item.type==999 ||
              item.type==98 ||
              item.type==96 ||
              item.type==19 ||
              item.type==20 ||
              item.type==21)&&item.code == ''? 'offdialog': 'offdialogs'">关闭弹窗</el-button>
            </div>
          </div>
          <div v-else-if="item.cmd == 'carport_push_sos'" class="newsosCapsBox">
            <!-- 车棚 -->
            <div style="position: relative;">
              <div class="colorBox" @click="closeSOS(item)">
                <i class="el-icon-close"></i>
              </div>
              <el-image fit="contain" :src="require(`@/assets/sosTitBg1.png`)" style="width:100%" />
              <div class="sosMsgHeader" style="color: #fff">
                <div class="sosTitle">
                  <p style="font-size:22px;font-weight: bolder">{{ item.sosName }}</p>
                  <p style="font-size:16px;">{{ item.closetime }}S</p>
                </div>
              </div>
            </div>
            <div class="sosMsgContent" style="padding: 10px 20px;">
              <div class="sosMsg" style="display:flex;align-items: flex-start;">
                <p style="width:27%;">电动车棚：</p>
                <p style="width:72%" :title="item.name" class="overName">{{ item.name }} </p>
              </div>
              <div class="sosMsg" style="margin: 10px 0">
                <p style="width:27%">报警时间：</p>
                <p style="width:72%">{{ item.time }} </p>
              </div>
              <div class="sosMsg">
                <p style="max-width:30%">报警摄像头：</p>
                <!-- {{item}} -->
                <p style="width:69%">{{ item.deviceName }} </p>
              </div>
            </div>
            <div class="sosMsgBottom">
              <el-button type="primary" size="small" v-if="item.code != '' && item.type != 35"
                @click="answerCarSOS(item)" style="width:100px; margin-right: 35px">接听</el-button>
              <el-button type="info" size="small" @click="closeSOS(item)"
                :class="item.code == '' && item.type != 35 ? 'offdialog': 'offdialogs'">关闭弹窗</el-button>
            </div>
          </div>
          <div v-else class="newsosCapsBox">
            <!-- 安全帽 -->
            <div style="position: relative;">
              <div class="colorBox" @click="closeSOS(item)">
                <i class="el-icon-close"></i>
              </div>
              <el-image fit="contain" :src="require(`@/assets/sosTitBg2.png`)" style="width:100%" />
              <div class="sosMsgHeader" style="color: #fff">
                <div class="sosTitle">
                  <p style="font-size:22px;font-weight: bolder">{{ item.sosName }}</p>
                  <p style="font-size:16px;">{{ item.closetime }}S</p>
                </div>
              </div>
            </div>
            <div class="sosMsgContent" style="padding: 0 20px;">
              <div class="sosMsg" style="display:flex">
                <p style="width:27%">报警设备：</p>
                <p style="width:72%">安全帽 </p>
              </div>
              <div class="sosMsg">
                <p style="width:27%">人员名称：</p>
                <p style="width:72%">{{ item.userName }} </p>
              </div>
              <div class="sosMsg">
                <p style="width:27%">报警时间：</p>
                <p style="width:72%">{{ item.sosTime }} </p>
              </div>
              <div class="sosMsg" style="display:flex">
                <p style="width:27%">报警位置：</p>
                <p style="width:72%">{{ item.address }} </p>
              </div>
            </div>
            <div class="sosMsgBottom">
              <el-button type="primary" size="small" @click="answerSOSCaps(item)">接听</el-button>
              <el-button type="info" size="small" @click="closeSOS(item)" style="margin-left: 70px">关闭弹窗</el-button>
            </div>
          </div>
        </div>
      </template>
      <!-- 电梯 -->
      <el-dialog v-if="visible" :visible.sync="visible" :close-on-click-modal="false" :show-close="showClose"
        width="950px" top="8vh" :modal="false" @closed="bclose">
        <div style="padding: 0 20px" class="scrollElement">
          <EditionC1 v-if="!isOldJk" ref="editionC1" :jkData="jkData" :sosId="sosId" :alarmTime="alarmTime"
            @bclose="bclose" :videoStatusId="videoStatusId" :id="device_id" :ids="ids"
            :dioDetailsItem="dioDetailsItem" />
          <EditionC2 v-else ref="editionC2" :jkData="jkData" :sosId="sosId" :alarmTime="alarmTime" @bclose="bclose"
            :id="device_id" :percentage="percentage" @changePercentage="changePercentage" :videoStatusId="videoStatusId"
            :ids="ids" :dioDetailsItem="dioDetailsItem" />
        </div>
        <div slot="footer" class="dialog-footer"></div>
      </el-dialog>

      <!-- 车棚 -->
      <el-dialog v-if="carVisible" :visible.sync="carVisible" :close-on-click-modal="false" :show-close="showClose"
        width="950px" top="8vh" :modal="false" @closed="bCarClose">
        <div style="padding: 0 20px" class="scrollElement">
          <SosCarDialog :deviceCode="dioDetailsItem.code" :sosId="dioDetailsItem.sosId" :bikeId="dioDetailsItem.bikeId"
            :sosDialog="true" @closed="bCarClose" />
        </div>
        <div slot="footer" class="dialog-footer"></div>
      </el-dialog>


      <!-- 安全帽 -->
      <el-dialog v-if="visibleCaps" :visible.sync="visibleCaps" :close-on-click-modal="false" :show-close="showClose"
        width="950px" top="8vh" :modal="false" @bcloseCaps="bcloseCaps">
        <div style="padding: 0 20px" class="scrollElement">
          <CapszlvScheme v-if="capsData" :jkData="capsData" @bcloseCaps="bcloseCaps" />
        </div>
        <div slot="footer" class="dialog-footer"></div>
      </el-dialog>
    </div>

    <!-- <el-dialog
			v-if="isPwdDio"
			:visible.sync="isPwdDio"
			width="500px"
			top="20vh"
			:close-on-press-escape="!tipPwdShow"
			:close-on-click-modal="!tipPwdShow"
			:show-close="!tipPwdShow"> -->
    <el-dialog v-if="isPwdDio" :visible.sync="isPwdDio" width="500px" top="20vh">
      <p v-if="tipPwdShow" class="tipPwd">检测到您的密码过于简单，请重新设置新密码</p>
      <div style="height: 240px;padding-right: 80px;">
        <el-form label-position="right" label-width="120px" ref="contracts" :model="contractForm" :rules="formRules">
          <el-row style="margin: 10px 0">
            <el-col :span="24">
              <el-form-item label="旧密码:" prop="password">
                <el-input placeholder="请输入" v-model="contractForm.password" class="wid90">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin: 10px 0">
            <el-col :span="24">
              <el-form-item label="新密码:" prop="newPassword">
                <el-input placeholder="请输入" v-model="contractForm.newPassword" class="wid90">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin: 10px 0">
            <el-col :span="24">
              <el-form-item label="确认密码:" prop="obNewPassword">
                <el-input placeholder="请输入" v-model="contractForm.obNewPassword" class="wid90">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="setPwd">确 定</el-button>
        <el-button v-if="!tipPwdShow" size="small" @click="isPwdDio = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-container>
      <!-- 侧边栏 -->
      <el-aside width="auto">
        <div @click="isCartes.i = false">
          <!-- 导航菜单 -->
          <el-menu :default-active="this.$route.matched[1].meta.lab" class="el-menu-vertical-demo"
            :collapse="isCollapse" text-color="#bfcbd9" unique-opened>
            <router-link v-if="bigScreenType == 1" to="">
              <el-menu-item @click="openNewPage('/newBigmianban')" index="0" style="text-align: left; width: 100%">
                <i class="el-icon-s-home"></i>
                <span slot="title">数据监控</span>
              </el-menu-item>
            </router-link>
            <router-link v-if="bigScreenType == 3" to="">
              <el-menu-item @click="openNewPage('/maintenanceBigmianban')" index="0"
                style="text-align: left; width: 100%">
                <i class="el-icon-s-home"></i>
                <span slot="title">数据监控</span>
              </el-menu-item>
            </router-link>
            <!-- @click="pushList('home', '/operate', '0')" -->
            <router-link v-if="bigScreenType == 2" to="">
              <el-menu-item @click="openNewPage('/operate')" index="0" style="text-align: left; width: 100%">
                <i class="el-icon-s-home"></i>
                <span slot="title">数据监控</span>
              </el-menu-item>
            </router-link>
            <!-- <router-link to="">
							<el-menu-item
								@click="toAD"
								index="-1"
								style="text-align: left; width: 100%"
							>
								<i class="el-icon-s-marketing"></i>
								<span slot="title">广告平台</span>
							</el-menu-item>
						</router-link> -->
            <el-submenu :index="item.id" style="text-align: left; width: 100%" v-for="(item, index) in elList">
              <template slot="title">
                <div style="width: 100%;height: 100%;" @click="openPage(item)">
                  <i class="el-icon-s-marketing"></i>
                  <span>{{ item.name }}</span>
                </div>
              </template>
              <router-link v-for="(items, indexs) in elList[index].children" :to="items.routePath">
                <el-menu-item @click="pushList(items.name, items.routePath, items.id)"
                  style="text-align: left; width: 100%" :index="items.id">
                  <span>{{ items.name }}</span>
                </el-menu-item>
              </router-link>
            </el-submenu>
          </el-menu>
        </div>
      </el-aside>
      <el-container>
        <!-- 头部 -->
        <el-header>
          <div class="headerRec" @click="isCartes.i = false">
            <div class="headerRecTop">
              <div class="hTop01">
                <span class="hTop01Tit">
                  <span v-if="platformName&&!$store.state.isZx && windowHost">
                    <span>{{platformName}}</span>
                  </span>
                  <span v-else>
                    <span v-if="$store.state.isZx">中信</span>数字化电梯物联网<span v-if="!$store.state.isZx">安全</span>监管系统</span>
                </span>
                <!-- <div>
									<i @click="setimg" class="el-icon-s-fold" style="font-size: 20px;"></i>
								</div> -->
                <!-- 面包屑 -->
                <!-- <div>
									<el-breadcrumb separator-class="el-icon-arrow-right"
										style="margin-left: 25px;height: 14px;overflow: hidden;">
										<el-breadcrumb-item :to="{ path: '/dashboard' }">
											<font @click="pushList('home','/dashboard','1')">{{$t('homes.home')}}</font>
										</el-breadcrumb-item>
										<el-breadcrumb-item v-for="(item,index) in this.$route.matched"
											v-if='item.name!="home" && item.name!=undefined'>
											{{$t('homes.'+item.name)}}
										</el-breadcrumb-item>
									</el-breadcrumb>
								</div> -->
              </div>
              <div class="hTop02">
                <!-- 全屏 -->
                <!-- <el-tooltip class="item" effect="dark" :content='isfull?"取消全屏":"全屏"' placement="bottom">
									<img @click="full()" style="width: 30.4px;height: 30.4px;margin-right: 10px;"
										src="../../assets/full.jpg" />
								</el-tooltip> -->

                <!-- 颜色选择器 -->
                <!-- <el-tooltip class="item" effect="dark" content="换肤" placement="bottom">
									<ThemeCom :color="color" @color-update="colorChange" />
								</el-tooltip> -->

                <!-- 中英文切换 -->
                <!-- <el-row class="block-col-2">
									<el-col :span="12">
										<el-dropdown trigger="click">
											<span class="el-dropdown-link">

												<el-tooltip class="item" effect="dark" content="中英文切换"
													placement="bottom">
													<img style="width: 30.4px;height: 30.4px;margin-left: 10px;"
														src="../../assets/ec.jpg" />
												</el-tooltip>

											</span>
											<el-dropdown-menu slot="dropdown">
												<div style="width: 100%;height: 100%;" @click="chin(0)">
													<el-dropdown-item>
														中文
													</el-dropdown-item>
												</div>
												<div style="width: 100%;height: 100%;" @click="chin(1)">
													<el-dropdown-item>
														English
													</el-dropdown-item>
												</div>
											</el-dropdown-menu>
										</el-dropdown>
									</el-col>
								</el-row> -->
                <el-button @click="gotoHome" type="text"
                  v-if="Number(adminInfo.roleId) != 8 && Number(adminInfo.roleId) != 9">返回首页</el-button>
                <!-- 头像 -->
                <el-dropdown style="margin-right: 50px; margin-left: 20px">
                  <span class="el-ds">
                    <el-avatar size="medium" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png">
                    </el-avatar>
                    <span>{{ adminInfo.name }}</span>
                    <i class="el-icon-caret-bottom"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <div style="margin-right: 10px;display: flex;align-items: center;">
                      <span :style="{'color':seleTheme?'black':'white'}" style=" #606266 !important">
                        <el-dropdown-item> 简洁模式: </el-dropdown-item></span>
                      <el-switch v-model="seleTheme" @change="seleThemeChange" active-color="#13ce66"
                        inactive-color="#73cae1">
                      </el-switch>
                    </div>
                    <div style="width: 100%; height: 100%" @click="updPwd()">
                      <el-dropdown-item> 修改密码 </el-dropdown-item>
                    </div>
                    <div style="width: 100%; height: 100%" @click="quit()">
                      <el-dropdown-item> 退出登录 </el-dropdown-item>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="headerRecBottom">
              <!-- 自定义标签页 -->
              <tabControl :isCarte="isCartes" :routeDate="rdata" @goTag="goTag"></tabControl>
            </div>
          </div>
        </el-header>

        <el-main class="rtgg2" ref="rtgg">
          <div @click="isCartes.i = false" id="das" ref="pageBox">
            <router-view @click="isCartes.i = false" />

            <el-backtop target=".el-main" :visibility-height="20" :bottom="100" :right="40" style="z-index: 99">
              <div class="el-icon-s-home eecon"></div>
            </el-backtop>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <!-- {{route.path}} -->

    <div v-show="showParticle" id="particles-js" class="particles"></div>

    <NoticeDialog v-if="noticeVisiblie" :noticeInfo="noticeInfo" @closeDialog="closeDialog" />
  </div>
</template>

<script>
  import screenfull from 'screenfull' //引入控制全屏的插件
  import tabControl from '../../components/tabControl.vue'
  import EditionC1 from '../../components/editionC1'
  import EditionC2 from '../../components/editionC2'
  import SosCarDialog from '@/components/sosCarDialog.vue';
  import CapszlvScheme from '../../components/cap/zlvSchemeCaps.vue'
  import {
    formatDate
  } from "@/util";
  import ThemeCom from '../../components/ThemeCom'
  import NoticeDialog from './noticeDialog.vue';



  let sosTime
  export default {
    components: {
      adminInfo: JSON.parse(sessionStorage.getItem('adminInfo')),
      tabControl,
      ThemeCom,
      EditionC1,
      EditionC2,
      CapszlvScheme,
      NoticeDialog,
      SosCarDialog
    },
    watch: {
      $route: function(to, from) {}
    },
    data() {
      var validateNewPwd = (rule, value, callback) => {
        let operation =
          /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%&^*()_——\-+=<>;？?:""{}|「」,.\\/'\[\]·！￥（）《》？：“”【】、；‘’，。]).{8,16}$/
        inpYz(rule, value, callback, true, operation, '密码长度为：8-16位，且必须包含大小写字母，数字与特殊符号')
      }
      var validateObPwd = (rule, value, callback) => {
        if (!value) {
          callback(new Error('确认密码不能为空'))
        } else {
          if (value !== this.contractForm.newPassword) {
            callback(new Error('再次输入的密码与新密码不同'))
          }
        }
        callback()
      }
      return {
        seleTheme: false,
        isOldJk: '',
        //
        adminInfo: null,
        isCartes: {
          i: false,
        },
        isCollapse: false,
        color: '#00F6FF ',
        isfull: false,
        elList: [],
        tpList: [],
        boxTpList: [],
        tpCapsList: [],

        rdata: {
          i: 1,
          tags: [],
        },
        sosTypeList: [],
        jkData: null, // 球机推拉流
        capsData: null, // 安全帽信息
        visible: false, // 平台监控弹框
        visibleCaps: false, // 安全帽监控弹框
        sosId: '',
        videoStatusId: '',
        ids: '',
        alarmTime: '',
        showClose: false,
        bigScreenType: '',
        dioDetailsItem: {},
        // 修改密码
        isPwdDio: false,
        formRules: {
          password: [{
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }],
          newPassword: [{
            required: true,
            validator: validateNewPwd,
            trigger: 'blur',
          }],
          obNewPassword: [{
            required: true,
            validator: validateObPwd,
            trigger: 'blur'
          }]
        },
        contractForm: {},
        image: require('@/assets/sos.png'),

        percentage: 0,
        device_id: '',

        platformName: JSON.parse(sessionStorage.getItem('adminInfo')).platformName,
        logoUrl: JSON.parse(sessionStorage.getItem('adminInfo')).logoUrl,
        windowHost: window.location.hostname != 'zxtlw.zyzntech.com',
        showParticle: this.$route.path == '/dashboard', // 粒子效果
        tipPwdShow: false,

        noticeVisiblie: false,
        noticeInfo: {},
        tpCarList: [],


        //车棚
        carVisible: false,

      }
    },
    methods: {
      seleThemeChange() {
        // this.$store.state.StaSeleTheme = this.seleTheme
        this.$store.commit('changeTheme', this.seleTheme)
        console.log(this.seleTheme, '666')
        var head = document.getElementById('changecss');
        if (this.seleTheme) {
          head.href = "./static/style/ThemesTwo.css"
        } else {
          head.href = "./static/style/ThemesOne.css"
        }
        sessionStorage.setItem('seleTheme', this.seleTheme)
      },
      //跳转广告平台
      toAD() {
        let adminInfo = JSON.parse(sessionStorage.getItem('adminInfo'))
        let httpUrl = window.location.hostname == ('zxtlw.zyzntech.com' || 'tzb.runde.pro') ?
          "https://ads.runde.pro/R3Login" : "http://ads-test.runde.pro:30002/R3Login"
        let username = adminInfo.name
        let time = Math.floor(new Date().getTime() / 1000 + 10000000)
        httpUrl = `${httpUrl}?username=${username}&time=${time}`
        window.open(httpUrl, "_blank");
      },
      setPwd() {
        this.$refs.contracts.validate(async (valid) => {
          if (valid) {
            if (this.contractForm.newPassword == this.contractForm.obNewPassword) {
              let data = {
                id: this.adminInfo.id,
                password: this.contractForm.password,
                newPassword: this.contractForm.newPassword
              }
              this.axios.post('/api/system/web/user/modifyPassword', data).then((res) => {
                if (res.data.success) {
                  this.isPwdDio = false
                  this.$message.success(res.data.msg)
                  this.loginOut()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
            } else {
              this.$message.error('两次密码输入不一致，请确认新密码！')
            }
          } else {
            this.$message.error('请将表单填写完整！')
          }
        })
      },
      updPwd() {
        this.isPwdDio = true
        this.contractForm = {}
      },
      gotoHome() {
        this.pushList('首页', '/dashboard', 1)
        this.$router.push('/dashboard')
      },

      openPage(data) {
        if (data.name == '数据统计' && this.$route.path != "/sjtjPage") {
          this.pushList('数据统计', '/sjtjPage', 99)
          this.$router.push('/sjtjPage')
        }
      },


      //当选择颜色主题时触发
      colorChange(color) {
        this.color = color
      },
      isCartesN() {
        this.isCartes = false
      },

      goTag(data) {
        this.showParticle = data.name == '首页'
      },
      pushList(lab, rou, ind) {
        console.log(lab, rou, ind, 6666)
        let paths = ''
        const router = JSON.parse(sessionStorage.getItem('adminInfo')).resource
        router.forEach(item => {
          if (item.children) {
            item.children.find(ids => {
              if (ids.path == rou) {
                console.log(ids.id, 66)
                paths = ids.id
              }
            })
          }
        })
        console.log(paths, 555)
        // if(router.children){
        //   console.log(router.children,444)
        // }
        this.showParticle = rou == '/dashboard'
        let isPush = true
        for (let i = 0; i < this.rdata.tags.length; i++) {
          if (this.rdata.tags[i].i == ind) {
            isPush = false
          }
        }
        this.rdata.i = ind
        if (isPush) {
          let listArr = {
            name: lab,
            i: ind,
            rot: rou,
          }
          this.rdata.tags.push(listArr)

        }
      },
      openNewPage(path) {
        window.open(`${window.location.origin}/#${path}`, "_blank");
      },
      setimg() {
        // 旋转加动画效果
        this.isCollapse = !this.isCollapse
        event.srcElement.style.transition = '0.5s'
        if (this.isCollapse) {
          event.srcElement.style.transform = 'rotate(180deg)'
        } else {
          event.srcElement.style.transform = 'rotate(0deg)'
        }
      },
      full() {
        screenfull.toggle()
        if (screenfull.toggle()) {
          this.isfull = !this.isfull
        } else {
          this.$message({
            message: '浏览器不能全屏',
            type: 'warning',
          })
        }
      },

      quit() {
        this.$confirm('是否退出?', '提示', {
            confirmButtonText: '退出',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            this.loginOut()
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消退出',

            })
          })
      },

      loginOut() {
        this.axios.post('/api/system/web/user/loginOut').then((res) => {
          if (res.data.success) {
            clearInterval(sosTime)
            // this.socketApi.onlineDevice = []
            this.socketApi.stopHeartBeat()
            sessionStorage.clear()
            this.$message({
              type: 'success',
              message: '退出成功!',
            })
            // document.cookie = "AdminToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            this.$router.push('/login')
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg,
            })
          }
        })
      },
      getType(type) {
        let obj = '未知报警'
        this.tpList.forEach((qs) => {
          if (qs.value == type) {
            obj = qs.label
            return obj
          }
        })
        return obj
      },
      getBoxType(type) {
        let obj = '未知报警'
        this.boxTpList.forEach((qs) => {
          if (qs.value == type) {
            obj = qs.label
            return obj
          }
        })
        return obj
      },
      getCarType(type) {
        let obj = '未知报警'
        this.tpCarList.forEach((qs) => {
          if (qs.value == type) {
            obj = qs.label
            return obj
          }
        })
        return obj
      },
      getCapsType(type) {
        let obj = '未知报警'
        this.tpCapsList.forEach((qs) => {
          if (qs.value == type) {
            obj = qs.label
            return obj
          }
        })
        return obj
      },

      changePercentage(data) {
        this.percentage = data
      },
      getStreamStatus(data) {
        this.device_id = data.device_id
        this.$http
          .get(`api/ele/web/getStreamStatus?id=${this.device_id}`)
          .then((res) => {
            if (res.data.success) {
              this.percentage = res.data.data ? 75 : 50
            } else {
              this.$message.error(res.data.msg)
            }
          })
      },

      // 接听
      answerSOS(data) {
        this.dioDetailsItem = data
        this.sosTypeList = this.sosTypeList.filter(
          (item) => item.sosId !== data.sosId
        )
        const datas = {
          current: 1,
          size: 10,
          name: data.name
        }
        this.$http.post('/api/ele/web/elevatorInfo/runningList', datas).then((res) => {
          console.log(res, 'res')
          if (res.data.code == 200) {
            this.ids = res.data.data.records ? res.data.data.records[0].id : ''
          }
        })
        document.getElementById('alarmA').pause()
        this.sosId = data.sosId
        this.videoStatusId = data.videoStatusId
        this.alarmTime = data.alarmTime
        setTimeout(() => {
          this.showClose = true
        }, 2000)
        const agentData = {
          act: 'ca_start_rtsp',
          device_id: data.code,
        }
        this.socketApi.sendSock(agentData, (e) => {
          if (e.status) {
            this.visible = true
            if (e.hb) {
              this.percentage = 25
            }
            if (e.cmd === 'ca_start_rtsp') {
              if (data.appVer.indexOf('C2') > -1 || data.appVer.indexOf('C3') > -1) {
                this.percentage = 50
                this.getStreamStatus(JSON.parse(e.data))
                this.isOldJk = true
              } else {
                this.isOldJk = false
              }
              const data1 = JSON.parse(e.data)
              data1.sip_id = data.sipId
              this.jkData = data1
            }
          } else {
            this.$message.error(e.msg)
            let agentData = {
              act: 'ma_stop_webrtc_call',
              sos_room_id: data.code,
            }
            this.socketApi.sendSock(agentData, (e) => {})
            this.visible = false
          }
        })
      },

      bclose() {
        this.visible = false
      },
      //车棚接听
      answerCarSOS(data) {
        this.carVisible = true
        console.log(data, 'data111111111111');

        this.dioDetailsItem = data
        this.sosTypeList = this.sosTypeList.filter(
          (item) => item.sosId !== data.sosId
        )
        document.getElementById('alarmA').pause()
        this.sosId = data.sosId
        this.videoStatusId = data.videoStatusId
        this.alarmTime = data.alarmTime
        setTimeout(() => {
          this.showClose = true
        }, 2000)
        // const agentData = {
        //   act: 'ca_start_rtsp',
        //   device_id: data.code,
        // }
        // this.socketCarportApi.sendCarportSock(agentData, (e) => {
        //   if (e.status) {
        //     this.carVisible = true
        //     if (e.cmd === 'ca_start_rtsp') {
        //         this.jkData = data1
        //     }
        //   } else {
        //     this.$message.error(e.msg)
        //     let agentData = {
        //       act: 'ma_stop_webrtc_call',
        //       sos_room_id: data.code,
        //     }
        //     this.socketCarportApi.sendCarportSock(agentData, (e) => {})
        //     this.carVisible = false
        //   }
        // })
      },

      bCarClose() {
        this.carVisible = false
      },


      // 安全帽接听
      answerSOSCaps(data) {
        this.sosTypeList = this.sosTypeList.filter(
          (item) => item.sosId !== data.sosId
        )
        document.getElementById('alarmA').pause()
        this.sosId = data.sosId
        this.alarmTime = data.time
        this.visibleCaps = true
        setTimeout(() => {
          this.showClose = true
        }, 2000)
        const agentData = {
          act: 'ma_start_rtsp',
          code: data.code
        }
        this.socketCapsApi.sendCapsSock(agentData, (e) => {
          if (e.status) {
            if (e.cmd == 'ma_start_rtsp' && e.data) {
              let data1 = JSON.parse(e.data)
              this.capsData = data1
            }
          } else {
            this.$message.error(e.msg)
          }
        })
      },
      bcloseCaps() {
        this.visibleCaps = false
      },
      // 拒接
      closeSOS(data) {
        console.log(data, this.sosTypeList, '拒接')
        this.sosTypeList = this.sosTypeList.filter(
          (item) => item.sosId !== data.sosId
        )
        if (this.sosTypeList.length === 0) {
          document.getElementById('alarmA').pause()
        }
      },
      getSosConfigObj(data) {
        const sosConfig = JSON.parse(sessionStorage.getItem("sosConfig"))
        let arr = sosConfig.filter(item => Number(item.sosType) == Number(data.type))
        return arr[0]
      },
      // 车棚
      getCarSosConfigObj(data) {
        // if (sessionStorage.getItem("bikeSosConfig") && sessionStorage.getItem("bikeSosConfig") != 'undefined') {
        const bikeSosConfig = JSON.parse(sessionStorage.getItem("bikeSosConfig"))
        let arr = bikeSosConfig.filter(item => Number(item.sosType) == Number(data.type))
        return arr[0]
        // } else {
        //   this.$message.error('请到电动车棚管理 -> 车棚管理设置, 设置报警信息')
        //   return
        // }
      },

      // 首页公告关闭
      closeDialog() {
        this.noticeVisiblie = false
      }
    },
    mounted() {
      this.$nextTick(() => {
        openLz()
        let ht = this.$refs.topbox.offsetHeight
        if (ht > 1000) {
          this.$store.state.tabHeight = this.$refs.topbox.offsetHeight * 0.7
        } else if (ht > 900) {
          this.$store.state.tabHeight = this.$refs.topbox.offsetHeight * 0.65
        } else if (ht > 700) {
          this.$store.state.tabHeight = this.$refs.topbox.offsetHeight * 0.45
        } else {
          this.$store.state.tabHeight = 300
        }

        if (!this.$store.state.isZx) {
          document.title = window.location.hostname != 'zxtlw.zyzntech.com' ? this.platformName : (this
            .$store.state.isZx ? '中信数字化电梯物联网监管系统' : '数字化电梯物联网安全监管系统')
          var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
          link.type = "image/x-icon";
          link.rel = "shortcut icon";
          link.href = this.logoUrl
          document.getElementsByTagName("head")[0].appendChild(link);
          sessionStorage.setItem('seleTheme', this.seleTheme)
        }
        if (!JSON.parse(sessionStorage.getItem('adminInfo')).weakPassword) {
          this.tipPwdShow = true
          this.updPwd()
        }
      })
    },
    created() {
      // this.seleTheme = localStorage.getItem('seleTheme')

      const screenData = JSON.parse(sessionStorage.getItem('adminInfo'))
      this.bigScreenType = screenData.bigScreenType

      this.$http
        .post('/api/system/web/dict/dictionary?codes=BUTTON_TYPE')
        .then((res) => {
          if (res.data.success) {
            sessionStorage.setItem(
              'BUTTON_TYPE',
              JSON.stringify(res.data.data.BUTTON_TYPE)
            )
          }
        })

      this.$http
        .post(
          "/api/system/web/dict/dictionary?codes=SOS_TYPE,CAP_SOS_TYPE,CARPORT_SOS_TYPE,HIGH_SOS_PARAM,LOW_SOS_PARAM")
        .then((res) => {
          if (res.data.success) {
            const Arr = res.data.data.SOS_TYPE.filter((item) => {
              if (screenData.userName != 'admin') {
                return item.value != '21' && item.value != '35'
              } else {
                return item
              }
            })
            this.tpList = Arr
            this.boxTpList = [...res.data.data.HIGH_SOS_PARAM, ...res.data.data.LOW_SOS_PARAM]
            this.tpCapsList = res.data.data.CAP_SOS_TYPE
            this.tpCarList = res.data.data.CARPORT_SOS_TYPE
            sosTime = setInterval(() => {
              // this.sosTypeList
              this.sosTypeList.forEach((qs, ind) => {
                qs.closetime -= 1
                if (qs.closetime <= 0) {
                  this.sosTypeList.splice(ind, 1)
                }
              })

              this.socketApi.sosPrompt.forEach((qs) => {
                if (this.sosTypeList.length > 9) {
                  this.sosTypeList.splice(0, 1)
                }
                qs.closetime = 30
                qs.time = formatDate(qs.time, "yyyy-MM-dd HH:mm:ss")
                qs.alarmTime = qs.time
                qs.typeShow = true
                if (qs.type === -1) {
                  qs.sosName = `${qs.terminalSosName}报警`
                } else {
                  if (qs.sosDeviceSign && qs.sosDeviceSign == 1) {
                    qs.sosName = this.getBoxType(qs.type)
                  } else {
                    qs.sosName = this.getType(qs.type)
                  }
                }
                let sosConfigType = []
                sosConfigType = JSON.parse(sessionStorage.getItem('sosConfig'))
                sosConfigType.map(item => {
                  if (item.sosType == qs.type) {
                    qs.showBoxType = item.sosLevel
                  }
                })
                this.sosTypeList.push(qs)
              })
              this.socketCapsApi.sosCapsPrompt.forEach((qs) => {
                if (this.sosTypeList.length > 9) {
                  this.sosTypeList.splice(0, 1)
                }
                qs.closetime = 30
                qs.typeShow = true
                qs.sosName = this.getCapsType(qs.sosType)
                qs.showBoxType = 3

                this.sosTypeList.push(qs)
              })

              // 车棚
              this.socketCarportApi.sosCarportPrompt.forEach((qs) => {
                if (this.sosTypeList.length > 9) {
                  this.sosTypeList.splice(0, 1)
                }
                qs.closetime = 30
                qs.time = formatDate(qs.time, "yyyy-MM-dd HH:mm:ss")
                qs.typeShow = true
                qs.sosName = this.getCarType(qs.type)
                this.sosTypeList.push(qs)
              })





              this.sosTypeList = this.sosTypeList.filter(item => {
                if (item.cmd.indexOf('cap') > -1) {
                  return item
                } else if (item.cmd == 'carport_push_sos') {
                  let data = this.getCarSosConfigObj(item)
                  return data && data.push == 1
                } else {
                  let data = this.getSosConfigObj(item)
                  return data && data.push == 1
                }
              })
              let voiceS = this.sosTypeList.filter(item => {
                // console.log(item,'items')
                let data = this.getSosConfigObj(item)
                let data1 = ''
                if (item.cmd == 'carport_push_sos') {
                  data1 = this.getCarSosConfigObj(item)
                  // console.log(11)
                  return (data1 && data1.voice == 1)
                } else {
                  // console.log(22)
                  return (data && data.voice == 1)
                }
                // return (data && data.voice == 1) || (data1 && data1.voice == 1)
              })
              // console.log(voiceS, 'voiceS')
              if (
                this.sosTypeList.length > 0 &&
                !this.visible &&
                !this.$global.openJK &&
                voiceS.length > 0
              ) {
                // console.log('有声音')
                setTimeout(() => {
                  document.getElementById('alarmA').loop = true
                  document.getElementById('alarmA').play()
                }, 100)
              } else {
                document.getElementById('alarmA').pause()
              }

              this.socketApi.clearSos()
              this.socketCarportApi.clearCarportSos()
              this.socketCapsApi.clearCapsSos()
            }, 1000)
          }
        })

      this.adminInfo = JSON.parse(sessionStorage.getItem('adminInfo'))
      this.elList = this.adminInfo.resource.filter(item => item.name != '数据监控')
      let obj = {
        name: this.$route.matched[1].name,
        i: this.$route.matched[1].meta.lab,
        rot: this.$route.matched[1].path,
      }
      this.rdata.tags.push(obj)
      this.rdata.i = obj.i


      this.$http
        .get('/api/system/web/announcement/getPopub?type=LOGIN_NOTICE')
        .then((res) => {
          if (res.data.success) {
            if (res.data.data.length > 0) {
              const noticeInfo = JSON.parse(localStorage.getItem('isShowNotice')) ?? []
              if (noticeInfo.length > 0 && noticeInfo.find(item => item.userName == this.adminInfo.userName)) {
                let userShowNotice = noticeInfo.find(item => item.userName == this.adminInfo.userName)
                if (userShowNotice.checked && new Date().getTime() < userShowNotice.time) {
                  this.noticeVisiblie = false
                } else {
                  this.noticeVisiblie = true
                }
              } else {
                this.noticeVisiblie = true
              }
              this.noticeInfo = res.data.data[0]
            }

          }
        })
    },
    destroyed() {
      clearInterval(sosTime)
    },
  }
</script>

<style lang="scss" scoped>
  .tipPwd {
    margin: 0 auto 30px;
    text-align: center;
    color: #F00;
    font-size: 16px;
  }

  .particles {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .sosCallBox {
    width: 365px;
    min-height: 315px;
    margin-right: 15px;
    margin-bottom: 15px;
    background-color: #fff;
    border-radius: 5px;

    .newsosBox,
    .newsosCapsBox {
      .colorBox {
        position: absolute;
        top: 10px;
        z-index: 999;
        right: 10px;
        color: #fff;
      }

      .sosMsgHeader {
        display: flex;
        // position: relative;
        z-index: 999;
        justify-content: space-between;
        padding: 10px;
        color: rgb(255, 255, 255);
        position: absolute;
        top: 10px;
        right: 25px;

        .sosTitle {
          width: 215px;
          line-height: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }

      .sosMsgContent {
        .sosMsg {
          margin: 10px 0;
          display: flex;
          align-items: center;

          p {
            margin: 0;
          }
        }
      }

      .sosMsgBottom {
        padding: 0 20px;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .offdialog {
        width: 100px;
      }

      .offdialogs {
        width: 100px;
        // margin-left: 70px
      }
    }

    .newsosCapsBox {
      .sosMsgContent {
        .sosMsg {
          margin: 5px 0
        }
      }

      .sosMsgBottom {
        margin-top: 15px;
      }

      // .sosMsgBottom{
      // 	margin: 10px 0px 15px;
      // 	display: flex;
      // 	flex-direction: column;
      // 	justify-content: space-between;
      // 	min-height: 200px;
      // 	.sosMsg {
      // 		font-size: 15px;
      // 		margin-top: 10px;
      // 		display: flex;
      // 		width: 100%;
      // 		overflow: hidden;
      // 		text-overflow: ellipsis;
      // 		display: -webkit-box;
      // 		-webkit-line-clamp: 4;
      // 		-webkit-box-orient: vertical;
      // 		word-wrap: break-word;
      // 	}
      // }
    }
  }

  .sosCallBox span {
    font-size: 18px;
    font-weight: bold;
  }

  .sosBox {
    width: 100%;

    .sosMsgBottom {
      margin: 10px 0px 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 200px;

      .sosMsg {
        font-size: 16px;
        margin-top: 15px;
        display: flex;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
    }
  }

  .sosCapsBox {
    .sosMsgBottom {
      margin: 10px 0px 15px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: 200px;

      .sosMsg {
        font-size: 15px;
        margin-top: 10px;
        display: flex;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
    }
  }

  .sosCall {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999;
    /* width: 100%; */
    /* overflow: auto; */
    display: flex;
    flex-wrap: wrap;
  }

  .overName {
    max-height: 61px;
    // line-height: 60px;
    overflow: hidden; // 溢出的内容隐藏
    text-overflow: ellipsis; // 溢出的部分用省略号...显示
    -webkit-line-clamp: 3; // 行数
    display: -webkit-box; // 将对象作为弹性伸缩盒子模型显示
    -webkit-box-orient: vertical; // 设置或检索伸缩盒对象的子元素的排列方式
  }



  .rtgg2 {
    height: calc(100vh - 100px);
    /* overflow-y: scroll; */
    /* overflow-x: hidden; */
    /* overflow: hidden; */
  }

  .el-main {
    padding: 20px 20px 15px;
  }

  /* 全屏样式 */
  a {
    text-decoration: none;
  }

  /* 容器 */
  .hTop01 {
    width: 50%;
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
  }

  .hTop02 {
    width: 50%;
    height: 100%;
    float: right;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    overflow: hidden;
  }

  /* 颜色选择器样式 */
  .el-color-dropdown__link-btn {
    display: none !important;
    color: red !important;
  }
</style>

<style scoped>
  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }

  .item>>>.el-input__inner {
    width: 160px !important;
    height: 28px !important;
    float: left;
    border: 1px solid black !important;
  }
</style>
